'use client';

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { SparklinePoint } from '@/lib/adminApi';

type Props = {
  data: SparklinePoint[];
};

export default function MiningChart({ data }: Props) {
  const formatted = data.map(d => ({
    ...d,
    dayLabel: new Date(d.day).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    }),
  }));

  return (
    <div style={{
      padding: 24,
      background: '#141414',
      border: '1px solid #2A2A2A',
      borderRadius: 14,
    }}>
      <div style={{ marginBottom: 20 }}>
        <h3 style={{
          margin: 0, color: '#F5F5F5',
          fontSize: 16, fontWeight: 700,
        }}>
          Mining per day
        </h3>
        <p style={{
          margin: '4px 0 0', color: '#6B6B6B', fontSize: 12,
        }}>
          Total SHIELD mined over the last 7 days
        </p>
      </div>

      <ResponsiveContainer width="100%" height={280}>
        <AreaChart data={formatted} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="miningGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#D4AF37" stopOpacity={0.4} />
              <stop offset="95%" stopColor="#D4AF37" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#2A2A2A" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="dayLabel"
            stroke="#6B6B6B"
            fontSize={11}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            stroke="#6B6B6B"
            fontSize={11}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            contentStyle={{
              background: '#0A0A0A',
              border: '1px solid #D4AF37',
              borderRadius: 8,
              color: '#F5F5F5',
              fontSize: 12,
            }}
            labelStyle={{ color: '#D4AF37', fontWeight: 700 }}
          />
          <Area
            type="monotone"
            dataKey="mined"
            stroke="#D4AF37"
            strokeWidth={2}
            fill="url(#miningGradient)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
